/* Oakline — predictive search */
(() => {
  if (customElements.get('predictive-search')) return;

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('.predictive-search');
      this.cache = new Map();
      if (!this.input || !this.results || this.dataset.enabled !== 'true') return;

      this.input.addEventListener(
        'input',
        window.theme.debounce(() => this.onInput(), 250)
      );
      this.input.addEventListener('keydown', (event) => this.onKeydown(event));
    }

    get term() {
      return this.input.value.trim();
    }

    onInput() {
      if (!this.term.length) {
        this.clear();
        return;
      }
      this.fetchResults(this.term);
    }

    async fetchResults(term) {
      const key = term.toLowerCase();
      if (this.cache.has(key)) {
        this.render(this.cache.get(key));
        return;
      }
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const params = new URLSearchParams({
        q: term,
        section_id: 'predictive-search',
        'resources[type]': 'product,collection,query,page',
        'resources[limit]': '8',
        'resources[options][unavailable_products]': 'last',
      });
      try {
        const response = await fetch(`${this.dataset.url}?${params.toString()}`, { signal: this.controller.signal });
        if (!response.ok) throw new Error(response.status);
        const html = await response.text();
        const markup = window.theme.parseHTML(html).querySelector('#shopify-section-predictive-search');
        const content = markup ? markup.innerHTML : '';
        this.cache.set(key, content);
        if (term === this.term) this.render(content);
      } catch (error) {
        if (error.name !== 'AbortError') this.clear();
      }
    }

    render(content) {
      this.results.innerHTML = content;
      this.input.setAttribute('aria-expanded', content.trim().length > 0 ? 'true' : 'false');
      this.activeIndex = -1;
    }

    clear() {
      this.results.innerHTML = '';
      this.input.setAttribute('aria-expanded', 'false');
    }

    onKeydown(event) {
      const options = [...this.results.querySelectorAll('[role="option"]')];
      if (!options.length) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const step = event.key === 'ArrowDown' ? 1 : -1;
        this.activeIndex = ((this.activeIndex ?? -1) + step + options.length) % options.length;
        options.forEach((option, index) => option.setAttribute('aria-selected', index === this.activeIndex ? 'true' : 'false'));
        options[this.activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && this.activeIndex > -1 && options[this.activeIndex]) {
        event.preventDefault();
        window.location.href = options[this.activeIndex].href;
      }
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
})();
